import Organization from "./organization";
import Project from "./project";

export default class ProjectCollection {
  public idProjectCollection: number = 0;
  public collectionName: string = "";
  public projects: Project[] = [];
  public organizations: Organization[] = [];
}
